import { apply, compose, leafBox, multiply } from './bounds.js';
/** Most spots along one part. */
const ALONG = 4;
export function glowSpots(parts) {
    const spots = [];
    const walk = (list, parent) => {
        for (const part of list) {
            if (part.type === 'group') {
                walk(part.parts, multiply(parent, compose(part.pos, part.rot, part.scale)));
                continue;
            }
            if (part.finish !== 'glow')
                continue;
            const place = multiply(parent, compose(part.pos, part.rot));
            // The groups' scale, alike in every direction: the length of a column.
            const scale = Math.hypot(place[0], place[4], place[8]);
            const box = leafBox(part);
            const middle = [0, 1, 2].map((i) => (box.min[i] + box.max[i]) / 2);
            const half = [0, 1, 2].map((i) => (box.max[i] - box.min[i]) / 2);
            const order = [0, 1, 2].sort((a, b) => half[b] - half[a]);
            const long = half[order[0]];
            const wide = half[order[1]];
            const count = wide > 0 && long > 2 * wide ? Math.min(ALONG, Math.floor(long / wide)) : 1;
            const colour = part.color.toLowerCase();
            for (let k = 0; k < count; k++) {
                const offset = count === 1 ? 0 : -long + (long / count) * (2 * k + 1);
                const axis = order[0];
                const local = middle.map((n, i) => (i === axis ? n + offset : n));
                spots.push({
                    centre: apply(place, local),
                    radius: Math.max(wide, long / count) * scale,
                    colour,
                });
            }
        }
    };
    walk(parts, compose(undefined, undefined));
    return spots;
}
//# sourceMappingURL=glow.js.map